import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import DialogModal from 'tradera-components/dialog/dialog-modal';
import CheckmarkIcon from '@tradera/blueprint/theme/icons2/check-circle.svg?jsx';
import AlertIcon from '@tradera/blueprint/theme/icons2/alert.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';

export const Dialog = ({
    title,
    text,
    icon,
    dismissActionText,
    onDismiss,
    confirmActionText,
    onConfirm
}) => {
    return (
        <DialogModal
            className="flex-column position-relative"
            mobileFullscreen={false}
            onDismiss={onDismiss}>
            <div className="p-4">
                <div
                    className="position-absolute"
                    style={{ top: '10px', right: '10px', zIndex: 1 }}>
                    <button className="btn btn-round" onClick={onDismiss}>
                        <CloseIcon className="icon icon-md" />
                    </button>
                </div>
                <h2 className="text-center text-styled mb-3">{title}</h2>
                <div className="d-flex justify-content-center mb-3">{icon}</div>
                <p className="text-center mb-3">{text}</p>
                {onConfirm ? (
                    <div className="row">
                        <button
                            data-test-confirm-end
                            className="btn btn-sm btn-primary col-12 col-sm-5 offset-sm-1 mr-sm-2 mb-2"
                            type="button"
                            onClick={onConfirm}>
                            {confirmActionText}
                        </button>
                        <button
                            className="btn btn-sm btn-outline-primary col-12 col-sm-5 ml-sm-2 order-sm-1"
                            type="button"
                            onClick={onDismiss}>
                            {dismissActionText}
                        </button>
                    </div>
                ) : (
                    <div className="d-flex justify-content-center">
                        <button
                            className="btn btn-sm btn-primary"
                            type="button"
                            onClick={onDismiss}>
                            {dismissActionText}
                        </button>
                    </div>
                )}
            </div>
        </DialogModal>
    );
};

export const SubmittedDialog = ({ submittedFeedbackCount, onDismiss }) => {
    const { t } = useTranslator();
    return (
        <Dialog
            title={t('leaveFeedback_submittedHeading', {
                count: submittedFeedbackCount
            })}
            text={t('leaveFeedback_submittedMessage')}
            icon={<CheckmarkIcon className={`icon icon-xl`} />}
            dismissActionText={t('leaveFeedback_submittedClose')}
            onDismiss={onDismiss}
        />
    );
};

export const SubmitErrorDialog = ({ onDismiss }) => {
    const { t } = useTranslator();
    return (
        <Dialog
            title={t('leaveFeedback_submittedErrorHeading')}
            text={t('leaveFeedback_submittedErrorMessage')}
            icon={<AlertIcon className={`icon icon-xl`} />}
            dismissActionText={t('leaveFeedback_submittedClose')}
            onDismiss={onDismiss}
        />
    );
};

export const AlreadySubmittedErrorDialog = ({ onDismiss }) => {
    const { t } = useTranslator();
    return (
        <Dialog
            title={t('leaveFeedback_feedbackAlreadyLeft')}
            text={''}
            icon={<AlertIcon className={`icon icon-xl`} />}
            dismissActionText={t('leaveFeedback_errorClose')}
            onDismiss={onDismiss}
        />
    );
};

export const ConfirmSubmitDialog = ({
    negativeCount,
    isInMultipleFeedbacksContext = false,
    onConfirm,
    onDismiss
}) => {
    const { t } = useTranslator();
    return (
        <Dialog
            title={t(
                isInMultipleFeedbacksContext && negativeCount > 0
                    ? 'leaveFeedback_negativeWarningTextWithCount'
                    : 'leaveFeedback_negativeWarningText',
                {
                    count: negativeCount
                }
            )}
            text={t('leaveFeedback_negativeDisclaimer')}
            icon={<AlertIcon className={`icon icon-xl`} />}
            dismissActionText={t('leaveFeedback_negativeWarningAbort')}
            onDismiss={onDismiss}
            confirmActionText={t('leaveFeedback_negativeWarningConfirm')}
            onConfirm={onConfirm}
        />
    );
};
